// AppRouter.js - Configuración de rutas con React Router
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './components/Toast';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import App from './App';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Pricing from './pages/Pricing';
import Refunds from './pages/Refunds';
import LibroReclamaciones from './components/LibroReclamaciones';
import PricingPageCulqi from './components/PricingPageCulqi';

const AppRouter = () => {
  return (
    <SubscriptionProvider>
      <ToastProvider>
        <Router>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/terminos" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/privacidad" element={<Privacy />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/precios" element={<PricingPageCulqi />} />
            <Route path="/refunds" element={<Refunds />} />
            <Route path="/devoluciones" element={<Refunds />} />
            <Route path="/libro-reclamaciones" element={<LibroReclamaciones />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ToastProvider>
    </SubscriptionProvider>
  );
};

export default AppRouter;